export default {
    isAvailable() {
        return window.__google_recaptcha_client;
    },
};
